import React, { useEffect, useState, memo } from 'react';

import Typo from 'components/ui/typo';
import config from 'utils/config';
import { calculateTimeRemaining } from 'utils/commonFunctions';

const CountDown = ({ utcTime, customCls, showSeconds, setDeadlineOver, matchNo, onBoardFlag }) => {
  const [countdown, setCountdown] = useState(calculateTimeRemaining(utcTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(calculateTimeRemaining(utcTime));
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    if (countdown?.isDeadLineExpired && setDeadlineOver) {
      setDeadlineOver(true);
    }
  }, [countdown?.isDeadLineExpired]);

  let showDay = showSeconds ? countdown.days >= 1 : true;
  let showSec = showSeconds ? countdown.days < 1 : false;
  // let showDay = false;
  // let showSec = false;

  return (
    <>
      <div className={`si-stopWatch__wrap ${customCls || ''}`}>
        {showDay ? (
          <div className='si-stopWatch__box'>
            <Typo component={'span'} transKey={''}>
              {countdown.days}
            </Typo>
            {!customCls ? (
              countdown.days === 1 ? (
                <Typo component={'em'} transKey={'countdown_day'}></Typo>
              ) : (
                <Typo component={'em'} transKey={'countdown_days'}></Typo>
              )
            ) : (
              <Typo component={'em'} transKey={'countdown_d'}></Typo>
            )}
          </div>
        ) : null}
        <div className='si-stopWatch__box'>
          <Typo component={'span'} transKey={'countdown_hour'}>
            {countdown.hours < 10 ? `0${countdown.hours}` : countdown.hours}
          </Typo>
          {!customCls ? (
            countdown.days === 1 ? (
              <Typo component={'em'} transKey={'countdown_hr'}></Typo>
            ) : (
              <Typo component={'em'} transKey={'countdown_hrs'}></Typo>
            )
          ) : (
            <Typo component={'em'} transKey={'countdown_h'}></Typo>
          )}
        </div>
        <div className='si-stopWatch__box'>
          <Typo component={'span'} transKey={'countdown_minute'}>
            {countdown.minutes < 10 ? `0${countdown.minutes}` : countdown.minutes}
          </Typo>
          {!customCls ? (
            countdown.days === 1 ? (
              <Typo component={'em'} transKey={'countdown_min'}></Typo>
            ) : (
              <Typo component={'em'} transKey={'countdown_mins'}></Typo>
            )
          ) : (
            <Typo component={'em'} transKey={'countdown_m'}></Typo>
          )}
        </div>
        {showSec ? (
          <div className='si-stopWatch__box'>
            <Typo component={'span'} transKey={'countdown_seconds'}>
              {countdown.seconds < 10 ? `0${countdown.seconds}` : countdown.seconds}
            </Typo>
            {!customCls ? (
              countdown.days === 1 ? (
                <Typo component={'em'} transKey={'countdown_sec'}></Typo>
              ) : (
                <Typo component={'em'} transKey={'countdown_secs'}></Typo>
              )
            ) : (
              <Typo component={'em'} transKey={'countdown_s'}></Typo>
            )}
          </div>
        ) : null}{' '}
        {customCls ? 'Left' : null}
        {onBoardFlag ? ` for M${matchNo}` : null}
      </div>
    </>
  );
};

// snippet
// {time && <Countdown utcTime={time} />}

// const [time, setTime] = useState(null);

// useEffect(() => {
//   const findFirstMatch = (fixtureData || [])?.find((fixture) => {
//     return fixture?.MatchStatus == 1;
//   });

//   setTime(findFirstMatch?.CompetitionTimeStartUtc);
//   setEventLogo(findFirstMatch?.Venue);
// }, [fixtureData]);

export default memo(CountDown);
